import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "common/extra-game-actions"

export const List = async () => {
    return await axiosInstance(options).get(`${path}/list`);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Update = async (id, values) => {
    return await axiosInstance(options).put(`${path}/admin/${id}`, values);
}

export const Delete = async (id) => {
    return await axiosInstance(options).delete(`${path}/${id}`)
}
